const systemSettings = {
  pageName: 'System Settings',
  templatePlaceholder: 'Select Template',
  templateLabel: 'Active System Settings Template',
  templateDescriptions: 'Choose a template from the dropdown above. The selected template will be applied when you tap on "Save".',
  switchButton: {
    label: 'View',
    options: {
      site: 'Site',
      account: 'Account',
    },
  },
  toasts: {
    successfully: 'Saved successfully',
    error: 'Error',
  },
  toastReset: {
    successfully: 'Restore to default completed successfully',
    error: 'Restore to default failed',
  },
  modalDelete: {
    header: 'Delete Template',
    body: 'You are about to delete a template?',
  },
  modalUnsaved: {
    header: 'Unsaved Changes',
    body: 'Changes made haven\'t been saved. Would you like to proceed without saving them?',
  },
  modalResetSettings: {
    header: 'Restore Default Settings',
    body: 'By proceeding, you will revert to the default settings, resulting in the loss of all the adjustments you\'ve made',
  },
  modalDeleteError: {
    header: 'Deleting an automation-enabled template',
    body: 'You\'re about to delete a template that linked to automations. To proceed with the deletion, you must first disconnect it from the associated automations.',
  }
};

export default systemSettings;
